<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Información General"
          directory="Edición"
          :icon="'trello'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              @click="returnPage()"
          >
            Regresar
          </button>
        </div>
      </div>
      <!-- <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <a href="/" class="btn btn-primary">Volver</a>
        </div>
      </div> -->
    </div>

    <div class="card card-with-shadow border-0 mb-primary">
      <div class="card-body">
        <form
          ref="form"
          class="mb-0"
          data-url="/register/users/updateInfoCompany"
          enctype="multipart/form-data"
          :class="{ 'loading-opacity': preloader }"
        >
          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">Información de la Compañia</h5>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("company_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.company_name"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_company_name')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("social_reason") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.social_reason"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_social_reason')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("ruc") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.ruc"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_ruc')"
                  />
                  <!-- <app-input
                    type="text"
                    v-model="inputs.ruc"
                    :min-length="5"
                    :max-length="13"
                    :required="true"
                    :disabled="disabledInfo"
                    v-on:keypress="isNumber"
                    @blur="handleBlur"
                    :placeholder="$t('type_ruc')"
                  /> -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("kind_society") }}</label>
                  <app-input
                    class="col-sm-8"
                    type="radio-buttons"
                    :disabled="disabledInfo"
                    v-model="inputs.society_type"
                    :list="kindOfSocietyLists"
                    :required="true"
                  />
                  <!-- <app-input
                    class="col-sm-8"
                    type="radio-buttons"
                    :disabled="disabledInfo"
                    v-model="inputs.society_type"
                    :list="kindOfSocietyLists"
                    @input="clicked"
                    :required="true"
                  /> -->
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("email") }}</label>
                  <app-input
                    type="email"
                    v-model="inputs.email"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_email')"
                  />
                  <span class="text-danger" v-if="msgEmail">
                    {{ msgEmail }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("company_address") }}</label>
                  <app-input
                    type="text"
                    :disabled="disabledInfo"
                    v-model="inputs.company_address"
                    :required="true"
                  />
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("accreditation_area") }}</label>
                  <app-input
                    id="inputs_area_id"
                    type="select"
                    v-model="inputs.area_id"
                    :list="accreditationAreaList"
                    v-on:change="onChangeAccreditationArea"
                    :disabled="disableArea"
                    :required="true"
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label>{{ $t("activity") }}</label>
                  <app-input
                    id="inputs_activity_id"
                    type="select"
                    v-model="inputs.activity_id"
                    :list="accreditationActivityLists"
                    :disabled="disableArea"
                    :required="true"
                  />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label><span style="color: transparent;">hi</span></label>
                  <button
                  type="button"
                  class="btn btn-primary btn-with-shadow"
                  @click="editAreaAct"
                >
                  {{ $t("Habilitar") }}
                </button>
                </div>
              </div>
            
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label>{{ $t("country") }}</label>
                  <app-input
                    type="select"
                    v-model="inputs.country_id"
                    :required="true"
                    :disabled="disabledInfo"
                    :list="[
                      { id: '', value: 'Seleccione una opción' },
                      ...this.$store.state.common.countries,
                    ]"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <div v-if="provinceList.length > 1">
                    <label>{{ $t("province") }}</label>
                    <app-input
                      type="select"
                      v-model="inputs.province_id"
                      :required="true"
                      :disabled="disabledInfo"
                      :list="[
                        { id: '', value: 'Seleccione una opción' },
                        ...provinceList,
                      ]"
                    />
                  </div>
                  <div v-if="inputs.country_id && provinceList.length <= 1">
                    <label>{{ $t("Ciudad") }}</label>
                    <app-input
                      type="text"
                      v-model="inputs.city"
                      :disabled="disabledInfo"
                      :placeholder="$t('Ingrese Ciudad')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6" v-if="provinceList.length > 1">
                <div class="form-group">
                  <div>
                    <label>{{ $t("canton") }}</label>
                    <app-input
                      type="select"
                      v-model="inputs.canton_id"
                      :required="true"
                      :disabled="disabledInfo"
                      :list="[{ id: '', value: 'Seleccione una opción' }, ...cantonList]"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("phone") }}</label>
                  <app-input
                    type="tel-input"
                    v-model="inputs.phone"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_phone')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Extensión") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.phone_extension"
                    :required="false"
                    :disabled="disabledInfo"
                    :placeholder="$t('Extensión telefónica')"
                  />
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group">
            <div class="card card-with-shadow border-0 mb-primary">
              <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t("legal_rep") }}</h5>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("first_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.first_name"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_names')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("last_name") }}</label>
                  <app-input
                    type="text"
                    v-model="inputs.last_name"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_lastname')"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("Tipo de Identificación") }}</label>
                  <app-input
                    type="select"
                    v-model="inputs.taxid_legal_rep_type"
                    :required="true"
                    :disabled="disabledInfo"
                    :list="taxidTypeLists"
                    v-on:change="onChangeTaxIdType(inputs.taxid_legal_rep_type)"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>
                    {{ selectedTaxIdLabel ? selectedTaxIdLabel : $t('taxid_legal_rep') }}
                  </label>
                  <app-input
                    type="text"
                    v-model="inputs.taxid_legal_rep"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('Ingrese el documento de identidad')"
                    @keyup="handleTaxidLegalRepInput"
                  />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t("email") }}</label>
                  <app-input
                    type="email"
                    v-model="inputs.email_legal_rep"
                    :required="true"
                    :disabled="disabledInfo"
                    :placeholder="$t('type_email')"
                    @blur="handleBlurEmail"
                  />
                  <span class="text-danger" v-if="msgEmailRep">
                    {{ msgEmailRep }}</span
                  >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group"></div>
              </div>
            </div>
          </fieldset>

          <div class="card card-with-shadow border-0 mb-primary">
            <div class="card-header p-primary bg-transparent">
              <h5 class="card-title m-0">Adjuntos</h5>
            </div>
            <div class="card-body">
              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("taxid") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_ruc_url"
                    class="btn btn-success"
                    target="_blank"
                    v-if="inputs.attach_ruc_url"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="openDeleteModal('attach_ruc_url')"
                    v-if="inputs.attach_ruc_url"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                  <!-- <hr>
                  <app-input type="file"
                          :label="rucFile"
                          v-model="inputs.attach_ruc"
                          v-on:change="fileChoosen"/>
                  <br>
                  <small class="form-text text-muted">Archivo .pdf del Registro Unico de Contribuyentes MAX 2MB</small> -->
                </div>
                <div class="col-sm-10" v-if="!inputs.attach_ruc_url">
                    <div class="form-group">
                        <app-input type="file"
                                :label="attach_ruc ? attach_ruc.name : $t('upload_your_file')"
                                v-model="attach_ruc"
                                :required="true"/>
                        <small class="form-text text-muted">Archivo .pdf del Registro Unico de Contribuyentes MAX 5MB</small>
                    </div>
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("taxid_ci") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_taxid_url"
                    class="btn btn-success"
                    target="_blank"
                    v-if="inputs.attach_taxid_url"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="openDeleteModal('attach_taxid_url')"
                    v-if="inputs.attach_taxid_url"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                  <!-- <hr>
                  <app-input type="file"
                          :label="taxidFile"
                          v-model="inputs.attach_taxid"
                          v-on:change="fileChoosen"/>
                  <br>
                  <small class="form-text text-muted">Archivo .pdf del Cédula MAX 2MB</small> -->
                </div>
                <div class="col-sm-10" v-if="!inputs.attach_taxid_url">
                    <div class="form-group">
                        <app-input type="file"
                                :label="attach_taxid ? attach_taxid.name : $t('upload_your_file')"
                                v-model="attach_taxid"
                                :required="true"/>
                        <small class="form-text text-muted">Archivo .pdf de la Cédula MAX 5MB</small>
                    </div>
                </div>
              </div>

              <div class="form-group mb-primary row align-items-center">
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("legal_rep_attach") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_legalrep_url"
                    class="btn btn-success"
                    target="_blank"
                    v-if="inputs.attach_legalrep_url"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="openDeleteModal('attach_legalrep_url')"
                    v-if="inputs.attach_legalrep_url"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                  <!-- <hr>
                  <app-input type="file"
                  :label="legalRepFile"
                  v-model="inputs.attach_legalrep"
                  v-on:change="fileChoosen"/>
                  <br>
                  <small class="form-text text-muted">{{ $t('legal_rep_attach_note') }}</small> -->
                </div>
                <div class="col-sm-10" v-if="!inputs.attach_legalrep_url">
                    <div class="form-group">
                        <app-input type="file"
                                :label="attach_legalrep ? attach_legalrep.name : $t('upload_your_file')"
                                v-model="attach_legalrep"
                                :required="true"/>
                        <small class="form-text text-muted">Archivo .pdf del Nombramiento MAX 5MB</small>
                    </div>
                </div>
              </div>

              <div
                class="form-group mb-primary row align-items-center"
                v-if="inputs.attach_agreement_url"
              >
                <label class="col-sm-2 mb-sm-0">
                  <label>{{ $t("agreement") }}</label>
                </label>
                <div class="col-sm-8">
                  <a
                    :href="inputs.attach_agreement_url"
                    class="btn btn-success"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                  <!-- <hr>
                  <app-input type="file"
                  :label="agreementFile"
                  v-model="inputs.attach_agreement"
                  v-on:change="fileChoosen"/>
                  <br>
                  <small class="form-text text-muted">{{ $t('agreement_note') }}</small> -->
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <button
              type="submit"
              class="btn btn-success mr-2"
              @click.prevent="submit"
            >
              <i data-feather="check" class="pr-2" />Actualizar Información
            </button>

            <button
              type="submit"
              class="btn btn-info mr-2"
              @click.prevent="refreshFiles"
            >
              <i data-feather="file" class="pr-2" />Actualizar Reportes
            </button>

          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import { axiosGet } from "../../../../../../../../resources/js/app/helpers/AxiosHelper";
import axios from 'axios';

export default {
  name: "RegisterUpdateInfo",
  mixins: [FormMixin],
  props: {
    orgId: String,
    backUrl: {
      type: String,
      default: "/",
    },
  },
  data() {
    return {
      url: "",
      preloader: false,
      disabledInfo: false,
      rucFile: "Seleccionar Archivo",
      taxidFile: "Seleccionar Archivo",
      legalRepFile: "Seleccionar Archivo",
      agreementFile: "Seleccionar Archivo",
      selectedSocietyType: "",
      msgEmail: "",
      msgEmailRep: "",
      inputs: {
        company_name: null,
        social_reason: null,
        ruc: null,
        society_type: null,
        email: null,
        company_address: null,
        phone: null,
        country_id: null,
        province_id: null,
        canton_id: null,
        user_id: null,
        first_name: null,
        last_name: null,
        email_legal_rep: null,
        taxid_legal_rep: null,
        attach_ruc_url: null,
        attach_taxid_url: null,
        attach_legalrep_url: null,
        attach_agreement_url: null,
        taxid_legal_rep_type: null,
      },
      kindOfSocietyLists: [
        { id: "private", value: "Sociedad Privada" },
        { id: "public", value: "Sociedad Pública" },
        { id: "other", value: "Otro" },
      ],
      taxidTypeLists: [
        { id: "", value: "Seleccione" },
        { id: "ci", value: "Cédula de Identidad" },
        { id: "other", value: "Pasaporte" },
      ],
      provinceList: [],
      cantonList: [],
      accreditationAreaList: [],
      accreditationActivityList: [],
      accreditationActivityLists: [],
      disableArea: false,
      attach_ruc: null,
      attach_taxid: null,
      attach_legalrep: null,
      selectedTaxIdLabel: ''
    };
  },
  watch: {
    "inputs.email": function () {
      let email = this.inputs.email;
      this.validateEmail(email, true);
    },
    "inputs.email_legal_rep": function () {
      let email = this.inputs.email_legal_rep;
      this.validateEmail(email, false);
    },
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
      
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.province_id
      );
    },

    "$store.state.common.countries": function() {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
      this.cantonList = this.$store.getters.getCantons(
        this.inputs.province_id
      );
    },

    
  },

  /* computed: {
    accreditationAreaList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions.accreditationAreas,
      ];
    },
    accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    },
  }, */

  created() {
    this.data();
  },
  methods: {
    handleBlur(e) {
      if (e.target.value.length === 13) {
        if (["public", "private"].includes(this.inputs.society_type)) {
          this.validateTaxid("ruc");
        }
      }
    },
    clicked(event) {
      if (["public", "private"].includes(this.inputs.society_type)) {
        if (this.inputs.ruc && this.inputs.ruc.length === 13) {
          this.validateTaxid("ruc");
        } else {
          this.inputs.ruc = null;
          this.$toastr.e("El campo RUC es obligatorio y debe tener 13 digitos");
        }
      }
    },
    handleBlurEmailCompany() {
      this.validateEmailCompany();
    },
    validateEmailCompany() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/validateEmailCompany/${this.inputs.email}?orgId=${this.orgId}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.inputs.email = null;
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    handleBlurCI(e) {
      if (e.target.value.length === 10) {
        this.validateTaxid("ci");
      }
    },
    handleBlurEmail(e) {
      this.validateEmail2();
    },
    validateEmail2() {
      this.preloader = true;
      let url = `${actions.USERS_REGISTER}/validateEmail/${this.inputs.email_legal_rep}?userId=${this.inputs.user_id}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              this.inputs.email_legal_rep = null;
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    validateEmail(value, type) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        if (type) {
          this.msgEmail = "";
        } else {
          this.msgEmailRep = "";
        }
      } else {
        if (type) {
          this.msgEmail = "Dirección de correo electrónico no válida";
        } else {
          this.msgEmailRep = "Dirección de correo electrónico no válida";
        }
      }
    },
    validateTaxid(type) {
      this.preloader = true;
      let url;
      if (type === "ruc") {
        url = `${actions.USERS_REGISTER}/validate/${this.inputs.ruc}/${this.inputs.society_type}?orgId=${this.orgId}`;
      } else if (type === "ci") {
        url = `${actions.USERS_REGISTER}/validate/${this.inputs.taxid_legal_rep}/${type}?orgId=${this.orgId}`;
      }
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            if (!response.data.validate) {
              if (type === "ruc") {
                this.inputs.ruc = null;
                this.inputs.society_type = null;
              } else if (type === "ci") {
                this.inputs.taxid_legal_rep = null;
              }
              this.$toastr.e(response.data.message);
            }
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.area_id;
        }),
      ];
    },

    onChangeTaxIdType(selectedValue) {
      const selectedOption = this.taxidTypeLists.find(
        (item) => item.id === selectedValue
      );
      if (selectedOption) {
        this.selectedTaxIdLabel = selectedOption.value;
      } else {
        this.selectedTaxIdLabel = this.$t('taxid_legal_rep'); // fallback
      }
    },
    validateEmailInput(value, type) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        if (type) {
          this.msgEmail = "";
        } else {
          this.msgEmailRep = "";
        }
      } else {
        if (type) {
          this.msgEmail = "Dirección de correo electrónico no válida";
        } else {
          this.msgEmailRep = "Dirección de correo electrónico no válida";
        }
      }
    },
    fileChoosen(event) {
      if (event.target.files[0].type === "application/pdf") {
        if (event.target.files[0].size < 2111775) {
          if (event.srcElement.id === "inputs_attach_ruc") {
            this.rucFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_taxid") {
            this.taxidFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_legalrep") {
            this.legalRepFile = event.target.files[0].name;
          }

          if (event.srcElement.id === "inputs_attach_agreement") {
            this.agreementFile = event.target.files[0].name;
          }
        } else {
          this.$toastr.e("El archivo PDF no debe exceder los 2MB.");
        }
      } else {
        this.$toastr.e("Solo permitidos archivos .pdf");
      }
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {


      // if (this.orgId) {
      //   this.inputs.id = this.orgId;
      // } else {
      //   this.inputs.id = localStorage.getItem("id_organization");
      // }

      this.inputs.id = this.orgId ? this.orgId : localStorage.getItem("id_organization");

      if (this.inputs.country_id == 1) {
        this.inputs.city = null;
      } else {
        this.inputs.province_id = null;
        this.inputs.canton_id = null;
      }

      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      formData.append(
        "attach_ruc",
        this.attach_ruc
      );
      formData.append(
        "attach_taxid",
        this.attach_taxid
      );
      formData.append(
        "attach_legalrep",
        this.attach_legalrep
      );
      this.save(formData);
    },
    afterSuccess(response) {
      this.preloader = true;
      if (response.status == 200) {
        this.$toastr.s("Información actualizada exitosamente.");
        this.data();
      }
    },
    afterFinalResponse() {
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getInfo() {
      this.preloader = true;
      let url = `${actions.COMMON_POLITICAL_DIVISION}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.countryLists = response.data.countries;
            this.countryList = [
              ...this.countryLists.filter((item) => {
                return item;
              }),
            ];
            this.provinceLists = response.data.provinces;
            this.provinceList = [
              ...this.provinceLists.filter((item) => {
                return item;
              }),
            ];
            this.cantonLists = response.data.cantons;
            this.cantonList = [
              ...this.cantonLists.filter((item) => {
                return item;
              }),
            ];
          }
        })
        .catch(({ error }) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    data() {
      this.preloader = true;
      this.$store.dispatch("getPoliticalDivision");
      this.rucFile = "Seleccionar Archivo";
      this.taxidFile = "Seleccionar Archivo";
      this.legalRepFile = "Seleccionar Archivo";
      this.agreementFile = "Seleccionar Archivo";

      let uraa = `/accreditations/applications/getActivitiesMix`;
      axiosGet(uraa).then((response) => {
        this.accreditationAreaList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accArea,
        ];

        this.accreditationActivityList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accActivitie,
        ];

      });

      let uri = `/accreditations/applications/options`;
      axiosGet(uri).then((response) => {
        // this.accreditationAreaList = [
        //   { id: "", value: "Selecciona una opción" },
        //   ...response.data.accreditationAreas,
        // ];

        // this.accreditationActivityList = [
        //   { id: "", value: "Selecciona una opción" },
        //   ...response.data.accreditationActivities,
        // ];

        let url = "";
        if (this.orgId) {
          url = `${actions.USERS_REGISTER}/form/${this.orgId}`;
        } else {
          url = `${actions.USERS_REGISTER}/form/${localStorage.getItem(
            "id_organization"
          )}`;
        }
        this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.inputs.company_name = response.data.organization.name;
              this.inputs.social_reason =
                response.data.organization.business_name;
              this.inputs.ruc = response.data.organization.taxid;
              this.inputs.society_type =
                response.data.organization.organization_type;
              this.inputs.email = response.data.organization.email;
              this.inputs.company_address = response.data.organization.address;
              this.inputs.phone = response.data.organization.phone;
              this.inputs.phone_extension =
                response.data.organization.phone_extension;
              this.inputs.country_id = response.data.organization.country_id;
              this.inputs.province_id = response.data.organization.province_id;
              this.inputs.canton_id = response.data.organization.canton_id;
              this.inputs.city = response.data.organization.city;
              this.inputs.area_id = response.data.organization.area_id;
              if(response.data.organization.area_id){
                this.onChangeAccreditationArea();
                this.inputs.activity_id = response.data.organization.activity_id;
              }
              
              this.inputs.user_id = response.data.organization.user.id;
              this.inputs.first_name =
                response.data.organization.user.first_name;
              this.inputs.last_name = response.data.organization.user.last_name;
              this.inputs.email_legal_rep =
                response.data.organization.user.email;
              this.inputs.taxid_legal_rep_type =
                response.data.organization.legal_representative_taxid_type;
              this.inputs.taxid_legal_rep =
                response.data.organization.legal_representative_taxid;
              for (
                let i = 0;
                i < response.data.organization.user.file.length;
                i++
              ) {
                if (response.data.organization.user.file[i].type === "ruc") {
                  this.inputs.attach_ruc_url =
                    response.data.organization.user.file[i].full_url;
                }
                if (response.data.organization.user.file[i].type === "taxid") {
                  this.inputs.attach_taxid_url =
                    response.data.organization.user.file[i].full_url;
                }
                if (
                  response.data.organization.user.file[i].type === "legalrep"
                ) {
                  this.inputs.attach_legalrep_url =
                    response.data.organization.user.file[i].full_url;
                }
                if (
                  response.data.organization.user.file[i].type === "agreement"
                ) {
                  this.inputs.attach_agreement_url =
                    response.data.organization.user.file[i].full_url;
                }
              }
              // this.getInfo();   
              if (this.country_id == 1) {
                this.provinceList = [
                  { id: null, value: null },    // índice 0
                  { id: null, value: null },    // índice 1
                  { id: "", value: "Seleccione Provincia" } // índice 2
                ];
              } else {
                this.provinceList = [];
              }       
              this.visibleArea();
              this.onChangeTaxIdType(response.data.organization.legal_representative_taxid_type);
            }
          })
          .catch(({ response }) => {
            console.log(response);
          })
          .finally(() => {
            this.preloader = false;
          });
      });
    },
    visibleArea() {
      let urll = "";
        if (this.orgId) {
          urll = `${actions.USERS_REGISTER}/form/${this.orgId}`;
        } else {
          urll = `${actions.USERS_REGISTER}/form/${localStorage.getItem(
            "id_organization"
          )}`;
        }
        this.axiosGet(urll)
          .then((response) => {
            if (response.status == 200) {
              this.inputs.area_id = response.data.organization.area_id;
              if(this.inputs.area_id) {
                this.disableArea = true;
              }
            }
          });
    },
    editAreaAct() {
      this.disableArea = false;
    },
    openDeleteModal(fileName) {
      this.inputs[fileName] = null;
      // this.deleteModal = true;
    },
    returnPage() {
      window.location.href = `/accreditationtechnical/info-oec`;
    },
    refreshFiles(){
        const url = '/register/users/updateFiles';
        const form  = new FormData();
        form.append('orgId', this.orgId);
        axios.post(url,form)
        .then((response) => {
          if(response.data.status){
            this.$toastr.s("Los cambios en los reportes pueden demorar entre 1 y 10 minutos en reflejarse.");
            return;
          }

          this.$toastr.e(response.data.message);
          
        })
        .catch(console.error)
        .finally(() => {})

    },
    handleTaxidLegalRepInput() {
      if (this.inputs.taxid_legal_rep_type == 'ci') {
        let cleaned = this.inputs.taxid_legal_rep.replace(/[^0-9]/g, '');
        cleaned = cleaned.slice(0, 10);
        this.inputs.taxid_legal_rep = cleaned;
      }
    }
  },
};
</script>
